import WarningIcon from '@app/components/icons/warning';
import { SupportLink } from '@app/components/support-link';
import { T } from '@app/components/translation';

import style from './error.module.scss';

export const PdfViewerError = () => (
  <div
    className={style.ErrorContainer}
    data-testid="error-container"
  >
    <WarningIcon height="40px" />
    <h1 className={style.Header}>
      <T
        _str="Something went wrong"
        _comment="Error message title"
      />
    </h1>
    <p data-testid="error-details">
      <T
        _str="Due to an internal error, we couldn’t load the PDF file."
        _comment="Error message to show the pdf file could not load"
      />
    </p>
    <p className={style.Contact}>
      <SupportLink />
    </p>
  </div>
);
